import CardFooter from "./CardFooter";
import { Stack, StackProps } from "@mui/material";
import CardHeader, { CardHeaderProps } from "./CardHeader";
import RefundStatusBox, { RefundStatusBoxProps } from "./RefundStatusBox";

function EmptyCard() {
    const stackProps: StackProps = {
        sx: {
            borderRadius: 1,
            overflow: "hidden",
            backgroundColor: "white",
            border: "1px solid #EDF0F3",
        },
    };

    const cardHeaderProps: CardHeaderProps = {
        title: "InstantVAT Faster VAT refunds",
    };

    const refundStatusBoxProps: RefundStatusBoxProps = {
        heading: "Refund status",
        subHeading: "View details",
        statusBoxItems: [
            {
                title: "Submit",
                value: "---",
            },
            {
                title: "HMRC verify",
                value: "---",
            },
            {
                title: "Payment",
                value: "---",
            },
        ],
    };

    return (
        <Stack {...stackProps}>
            <CardHeader {...cardHeaderProps} />
            <RefundStatusBox {...refundStatusBoxProps} />
            <CardFooter />
        </Stack>
    );
}

export default EmptyCard;
